
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Avignon dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Avignon certifiée Google Partner, accompagne les entreprises avignonnaises pour accroître leur notoriété en ligne et générer de nouveaux leads.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Avignon dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Avignon certifiée Google Partner, accompagne les entreprises avignonnaises pour accroître leur notoriété en ligne et générer de nouveaux leads.",
        },
      ],
    };
  },
};
